import React from "react";
import { Route, Routes } from "react-router-dom";
import { connect } from "react-redux";

import { MenuItem } from "../../types/system/MenuItem";
import MainToolbar from "../../components/toolbar/MainToolbar";
import SettingsMenu from "../../components/settings/SettingsMenu";
import PrintMenu from "../../components/printing/PrintMenu";
import DisplaySettings from "../../components/display/DisplaySettings";
import AlertDialog from "../../components/alerts/AlertDialog";
import Profile from "../../routes/global/Profile";
import Report from "../../routes/global/Report";
import ContextMenu from "../../components/contextmenu/ContextMenu";
import FileExplorerDialog from "../../components/fileExplorer/FileExplorerDialog";
import { IAppState } from "../../state/Store";
import ShareMenu from "../sharing/ShareMenu";
import ApplicationState from "../../foundation/AppState";
import MainToolbarContextContainer from "../toolbar/MainToolbarContext";

import "./Body.scss";
import ErrorBoundary from "../error/ErrorBoundary";

type BodyProps = {
    version: number;
    menuItems?: MenuItem[];
    userMenuClosed?: () => void;
    displayOpen?: boolean;
    displayClosed?: () => void;
    shareOpen?: boolean;
    shareClosed?: () => void;
    printOpen?: boolean;
    printClosed?: () => void;
    settingsOpen?: boolean;
    pageLoading: boolean;
};

type BodyState = {};

class Body extends React.Component<BodyProps, BodyState> {
    state = {};

    buildRoutes(allItems: MenuItem[], routes: JSX.Element[]): JSX.Element[] {
        routes = routes ?? [];

        allItems.forEach((item, index) => {
            if (item.path && item.component) {
                try {
                    const key = this.props.version * 100 + index;
                    const element = React.cloneElement(item.component, {
                        key: `dynamic-key-${key}`,
                    });
                    routes.push(
                        <Route
                            key={key}
                            path={item.path}
                            element={element}
                        />,
                    );
                } catch (error) {}
            }

            this.buildRoutes(item.children, routes);
        });

        const profileKey = this.props.version * 100 + 999;
        const profileElement = React.cloneElement(<Profile />, {
            key: `dynamic-key-${profileKey}`,
        });
        routes.push(
            <Route
                key={profileKey}
                path="/UserProfile"
                element={profileElement}
            />,
        );
        // routes.push(
        //     <Route
        //         key="Report"
        //         path="/Report/:id"
        //         element={<Report />}
        //     />,
        // );

        return routes;
    }

    render() {
        return (
            <MainToolbarContextContainer>
                <div
                    className="page-body"
                    data-contextkey="main-body">
                    <div className="page-content">
                        <ErrorBoundary sectionName="Main Toolbar">
                            <MainToolbar />
                        </ErrorBoundary>

                        {/* <search-bar className="no-print" open="searchOpen"
                                    expanded="replaceOpen">
                                </search-bar> */}

                        <ErrorBoundary sectionName="Main Tab Frame">
                            <div
                                className="tab-frame"
                                style={{ float: "left", width: "100%" }}>
                                <div className="tab-content fullSection">
                                    <ErrorBoundary sectionName="Main Components">
                                        <DisplaySettings
                                            open={this.props.displayOpen}
                                            displaySettingsClosed={
                                                this.props.displayClosed
                                            }></DisplaySettings>
                                        <ShareMenu
                                            open={this.props.shareOpen}
                                            shareClosed={
                                                this.props.shareClosed
                                            }></ShareMenu>
                                        <PrintMenu
                                            open={this.props.printOpen}
                                            printClosed={
                                                this.props.printClosed
                                            }></PrintMenu>
                                        <SettingsMenu
                                            open={
                                                this.props.settingsOpen
                                            }></SettingsMenu>
                                        <AlertDialog></AlertDialog>
                                        <FileExplorerDialog></FileExplorerDialog>
                                        <ContextMenu></ContextMenu>
                                    </ErrorBoundary>

                                    {/* <search-bar open="searchOpen"
                                    expanded="replaceOpen">
                                </search-bar> */}

                                    <ErrorBoundary sectionName="Route Information">
                                        <Routes>
                                            {this.buildRoutes(
                                                this.props.menuItems,
                                                [],
                                            )}
                                        </Routes>
                                    </ErrorBoundary>
                                </div>

                                {this.props.pageLoading ? (
                                    <div className="loader-mask no-print">
                                        <div className="loader"></div>
                                    </div>
                                ) : (
                                    <></>
                                )}
                            </div>
                        </ErrorBoundary>
                    </div>
                </div>
            </MainToolbarContextContainer>
        );
    }
}

const mapStateToProps = (state: IAppState) => {
    const { ui } = state.db;
    return {
        menuItems: ApplicationState.instance.menuItems,
        pageLoading: ui.pageLoading,
    };
};

const mapDispatchToProps = (dispatch: any) => {
    return {};
};

export default connect(mapStateToProps, mapDispatchToProps)(Body);
